import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useCommon from "hooks/useCommon";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import HotelSelector from "components/HotelSelector";
import Snackbar from "components/Snackbar";
import VuiInput from "components/VuiInput";
import InHouseGuestsTable from "./components/InHouseGuestTable";

const InHouseGuest = () => {
  const { DISPATCH, NAVIFATE, STORE } = useCommon();

  const [search, setSearch] = useState("");
  const [addUserOpen, setAddUserOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    color: "success",
    title: "",
    content: "",
    icon: "check",
  });

  const showSnackbar = ({ color, title, content, icon = "check" }) => {
    setSnackbar({
      show: true,
      color,
      title,
      content,
      icon,
    });
  };

  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, show: false }));

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <VuiBox>
        <VuiBox py={1}>
          <VuiBox mb={3}>
            <Card>
              <VuiBox mb="22px">
                {/* ===== Desktop / Large Screens (md+) ===== */}
                <VuiBox
                  display={{ xs: "none", md: "flex" }}
                  gap={2}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <VuiTypography variant="lg">In-House Guests</VuiTypography>

                  <VuiBox display="flex" gap={2} alignItems="center">
                    <HotelSelector />

                    <VuiBox sx={{ width: "220px" }}>
                      <VuiInput
                        gradient
                        fullWidth
                        placeholder="Search guests..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </VuiBox>

                    {/* <VuiButton
                      variant="contained"
                      color="primary"
                      sx={{ display: "flex", alignItems: "center", gap: "6px" }}
                    >
                      <FaPlus size="12px" />
                      <VuiTypography variant="text"  lineHeight={1}>
                        Add New
                      </VuiTypography>
                    </VuiButton> */}
                  </VuiBox>
                </VuiBox>

                {/* ===== Mobile / Small Screens (xs–sm) ===== */}
                <VuiBox display={{ xs: "block", md: "none" }}>
                  <VuiTypography
                    variant="lg"
                    sx={{
                      display: "block",
                      width: "100%",
                      textAlign: "left",
                      mb: 1,
                    }}
                  >
                    In-House Guests
                  </VuiTypography>

                  <VuiBox
                    mt={1}
                    mb={2}
                    sx={{ display: "flex", justifyContent: "center", width: "100%" }}
                  >
                    <HotelSelector minWidth={250} />
                  </VuiBox>

                  <VuiBox display="flex" justifyContent="center" gap={1}>
                    <VuiInput
                      gradient
                      fullWidth
                      placeholder="Search guests..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />

                    {/* <VuiButton
                      variant="contained"
                      color="primary"
                      sx={{
                        minWidth: 44,
                        px: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                      }}
                    >
                      <FaPlus size="12px" />
                      <VuiTypography
                        variant="text"
                        
                        sx={{ display: { xs: "none", sm: "block" }, lineHeight: 1 }}
                      >
                        Add New
                      </VuiTypography>
                    </VuiButton> */}
                  </VuiBox>
                </VuiBox>
              </VuiBox>

              <VuiBox
                sx={{
                  "& th": {
                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                      `${borderWidth[1]} solid ${grey[700]}`,
                  },
                  "& .MuiTableRow-root:not(:last-child)": {
                    "& td": {
                      borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                        `${borderWidth[1]} solid ${grey[700]}`,
                    },
                  },
                }}
              >
                <InHouseGuestsTable handleNotify={showSnackbar} search={search} />
              </VuiBox>
            </Card>
          </VuiBox>
        </VuiBox>
      </VuiBox>

      <Snackbar
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.content}
        open={snackbar.show}
        onClose={closeSnackbar}
        close={closeSnackbar}
      />
    </DashboardLayout>
  );
};

export default InHouseGuest;
